import axios from "axios";
import { useQuery } from "react-query";
import { BASE_API_URL } from "../utils/app-constants";


const LEAD_FORM_URL = `${BASE_API_URL}public/lead/form`;
const LEAD_SUBMIT_URL = `${BASE_API_URL}public/lead`;

// Questions and options are managed by marketing in the back office.
export const useLeadForm = () =>
  useQuery(
    ["lead-form"],
    async () => {
      const { data } = await axios.get(LEAD_FORM_URL);
      return data;
    },
    { staleTime: 2 * 60 * 1000, refetchOnWindowFocus: false, retry: 1 },
  );

export const submitLead = (payload) => axios.post(LEAD_SUBMIT_URL, payload);

// Platform and campaign come from the link marketing shares, e.g.
// /connect?src=facebook&campaign=oct-fish (UTM tags work too).
export const readSource = (search) => {
  const params = new URLSearchParams(search);
  return {
    platform: params.get("src") || params.get("utm_source") || "",
    campaign: params.get("campaign") || params.get("utm_campaign") || "",
  };
};

// One id per form fill. Re-sending after a network error reuses it, so the
// API never saves the same lead twice.
export const newSubmissionId = () => {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, "");
  }
  return (
    Date.now().toString(36) + Math.random().toString(36).slice(2, 12)
  ).slice(0, 32);
};

// Same rule as the API: Kenyan mobile numbers 07.. / 01.., with or without 254.
export const isKenyanMobile = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  let local = null;
  if (digits.length === 12 && digits.startsWith("254")) local = digits.slice(3);
  else if (digits.length === 10 && digits.startsWith("0"))
    local = digits.slice(1);
  else if (digits.length === 9) local = digits;
  return !!local && (local[0] === "7" || local[0] === "1");
};
